module.exports = __webpack_public_path__ + "static/Kontaktpfeil-d0395079c874a9a8968dc4fa102f7857.svg";